const cards = [
  {
    title: '丝瓜视频 - 热门影视资源站',
    desc: '提供最新电影、热播电视剧、综艺节目等海量视频内容，更新速度快，画质清晰流畅。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20home%20theater%20setup%20with%20large%20screen%20displaying%20cinematic%20content%20warm%20ambient%20lighting%20cozy%20atmosphere%20modern%20interior%20design%20coral%20and%20gold%20accent%20colors%20professional%20photography%20soft%20shadows%20high%20detail&width=400&height=280&seq=card-01-69&orientation=landscape',
    tag: '影视',
  },
  {
    title: '蓝莓视频 - 高清综艺娱乐',
    desc: '专注于综艺娱乐内容聚合，覆盖国内外热门综艺、真人秀、脱口秀等多元节目类型。',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20entertainment%20studio%20with%20dynamic%20stage%20design%20bright%20vibrant%20lighting%20modern%20broadcast%20environment%20professional%20production%20setup%20warm%20golden%20highlights%20clean%20composition%20high%20detail%20harmonious&width=400&height=280&seq=card-02-69&orientation=landscape',
    tag: '综艺',
  },
  {
    title: '糖心视频 - 甜美内容社区',
    desc: '以轻松愉快的视频内容为主，涵盖生活、美食、旅行等主题，为你带来每日好心情。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20lifestyle%20scene%20with%20decorative%20elements%20soft%20natural%20lighting%20cozy%20modern%20interior%20pastel%20warm%20tones%20with%20coral%20accents%20clean%20aesthetic%20composition%20professional%20photography%20high%20detail&width=400&height=280&seq=card-03-69&orientation=landscape',
    tag: '生活',
  },
  {
    title: '黑桃视频 - 独特内容频道',
    desc: '精选独特视角的视频内容，涵盖探险、科技、潮流文化等先锋话题，满足好奇心的探索。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20themed%20modern%20media%20room%20with%20geometric%20patterns%20and%20ambient%20lighting%20sleek%20design%20aesthetic%20warm%20coral%20neon%20accents%20against%20charcoal%20background%20cinematic%20atmosphere%20professional%20photography%20high%20detail&width=400&height=280&seq=card-04-69&orientation=landscape',
    tag: '探索',
  },
  {
    title: '妖精视频 - 潮流文化风向标',
    desc: '聚焦时尚潮流、音乐MV、创意短片等年轻化内容，展现最具活力的视频文化趋势。',
    img: 'https://readdy.ai/api/search-image?query=Trendy%20creative%20studio%20space%20with%20musical%20instruments%20and%20art%20supplies%20colorful%20vibrant%20atmosphere%20modern%20youth%20culture%20aesthetic%20warm%20coral%20and%20gold%20accents%20dynamic%20composition%20high%20detail%20professional%20photography&width=400&height=280&seq=card-05-69&orientation=landscape',
    tag: '潮流',
  },
  {
    title: '桃花视频 - 精品内容推荐',
    desc: '以精品推荐为核心，定期筛选优质视频资源，帮助用户在海量内容中快速发现佳作。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20curated%20gallery%20wall%20with%20framed%20artworks%20in%20warm%20lighting%20sophisticated%20interior%20design%20soft%20coral%20and%20cream%20tones%20refined%20aesthetic%20composition%20professional%20photography%20style%20high%20detail%20harmonious&width=400&height=280&seq=card-06-69&orientation=landscape',
    tag: '精选',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
            特色站点推荐
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10">
            精心挑选的优质视频平台，一站聚合随心切换
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.map((card, i) => (
              <article
                key={i}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-medium bg-accent-500 text-white whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {card.desc}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}